

<div class="row" *ngFor="let horario of hours; let i = index">
    <div class="col-xs-12 col-md-2">
        <mat-checkbox class="example-margin" [(ngModel)]="horario.dayOfWeek" 
         [ngModelOptions]="{standalone: true}" [value]="horario.dayOfWeek"
         (ngModelChange)="onChangeForm()"
         >{{ getDayOfWeekName(horario.dayOfWeek) }} </mat-checkbox>
    </div>
    <div class="col-xs-12 col-md-4">
        <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Início do atendimento</mat-label>
            <input type="text" matInput [ngModelOptions]="{standalone: true}"
            [(ngModel)]="horario.timeStart"  type=time
            (ngModelChange)="onChangeForm()"  
            placeholder="Atendimento a partir de">                                  
        </mat-form-field>                    
    </div>
    <div class="col-xs-12 col-md-4">
        <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Fim do atendimento</mat-label>
            <input type="text" matInput [ngModelOptions]="{standalone: true}"
            [(ngModel)]="horario.timeEnd"  type=time
            (ngModelChange)="onChangeForm()"
            placeholder="Atendimento até" >                                       
        </mat-form-field>
    </div>  
    <div class="col-xs-4 col-md-2 btAdd">
        <button mat-stroked-button color="primary"  (click)="addDayOfWeekTime(horario.dayOfWeek)">
            <mat-icon>add</mat-icon>
        </button>
        <button mat-stroked-button color="primary"  (click)="removeTime(i)">
            <mat-icon>remove</mat-icon>
        </button>
    </div>             
</div>
<mat-error *ngIf="!hasRightTime(hours[0])" align="center" style="margin-bottom: 15px;">
    A data de início tem que ser menor que a data de fim
</mat-error>   

<div class="col-xs-12 actions">
    <button mat-flat-button color="primary">Salvar alterações</button>
    <button mat-flat-button color="primary">Cadastrar</button>
</div>